import React from 'react';
import { useTranslation } from 'react-i18next';
import { Crown1, Messages2 } from 'iconsax-react';
import Button from '../../../components/atoms/Button';

interface TicketFooterProps {
  isLoading: boolean;
  hasTicket: boolean;
  canOpenChat: boolean;
  canCloseTicket: boolean;
  isCreatingChat: boolean;
  onCreateChat: () => void;
  onOpenCloseModal: () => void;
}

export const TicketFooter: React.FC<TicketFooterProps> = ({
  isLoading,
  hasTicket,
  canOpenChat,
  canCloseTicket,
  isCreatingChat,
  onCreateChat,
  onOpenCloseModal,
}) => {
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div className="flex justify-between items-center w-full animate-pulse">
        <div className="h-10 w-32 bg-gray-100 rounded-lg" />
        <div className="h-10 w-32 bg-gray-100 rounded-lg" />
      </div>
    );
  }

  if (!hasTicket || (!canOpenChat && !canCloseTicket)) {
    return null;
  }

  return (
    <div className="flex justify-between items-center w-full">
      {canOpenChat ? (
        <Button
          icon={<Messages2 size={18} />}
          variant="success"
          className="rounded-lg"
          loading={isCreatingChat}
          disabled={isCreatingChat}
          onClick={onCreateChat}
        >
          {t('support.chat', 'Chat')}
        </Button>
      ) : (
        <div />
      )}
      {canCloseTicket && (
        <Button
          icon={<Crown1 size={18} />}
          variant="info"
          className="rounded-lg"
          onClick={onOpenCloseModal}
        >
          {t('support.close_ticket', 'Close ticket')}
        </Button>
      )}
    </div>
  );
};

export default TicketFooter;
